(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collections-with-tabs"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.stl-tab').forEach(tab => {
  tab.addEventListener('click', () => {
    document.querySelectorAll('.stl-tab').forEach(t => t.classList.remove('active'));
    document.querySelectorAll('.stl-panel').forEach(p => p.classList.remove('active'));
    tab.classList.add('active');
    document.getElementById(tab.dataset.target).classList.add('active');
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);

  const hideMobileHeaderSearch = () => {
    if (!window.matchMedia('(max-width: 749px)').matches) return;

    document.querySelectorAll('.header-section input').forEach((input) => {
      const inputType = (input.getAttribute('type') || '').toLowerCase();
      const placeholder = (input.getAttribute('placeholder') || '').toLowerCase();
      const shouldHide =
        inputType === 'search' &&
        (placeholder.includes('search within') || placeholder.includes("search within men's"));

      if (!shouldHide) return;

      const target =
        input.closest('form') ||
        input.closest('.search-wrapper') ||
        input.closest('.search-bar') ||
        input.parentElement;

      if (target && target.closest('.header-section')) {
        target.style.display = 'none';
      }
    });
  };

  const forceQuickAddLabel = () => {
    document.querySelectorAll('.quick-add__button .add-to-cart-text__content span span').forEach((node) => {
      node.textContent = 'Quick Add';
    });
  };

  document.addEventListener(
    'DOMContentLoaded',
    () => {
      hideMobileHeaderSearch();
      forceQuickAddLabel();
      const grid = document.querySelector('.product-grid');
      if (grid) {
        grid.setAttribute('product-grid-view', 'default');
      }
      try {
        sessionStorage.setItem('product-grid-view-desktop', 'default');
        sessionStorage.setItem('product-grid-view-mobile', 'default');
      } catch (e) {}
    },
    { once: true }
  );
  window.addEventListener('resize', hideMobileHeaderSearch);
  document.addEventListener('shopify:section:load', () => {
    forceQuickAddLabel();
    const grid = document.querySelector('.product-grid');
    if (grid) {
      grid.setAttribute('product-grid-view', 'default');
    }
    try {
      sessionStorage.setItem('product-grid-view-desktop', 'default');
      sessionStorage.setItem('product-grid-view-mobile', 'default');
    } catch (e) {}
  });

  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
